module.exports = __webpack_public_path__ + "dimer/static/img/project4.534f0e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project4.jpg
// module id = xgVq
// module chunks = 0